module.exports = __webpack_public_path__ + "static/media/tool2.0c116efd.png";